import { compact, get, isEmpty } from "lodash";
import { capitalizeWithSeparators } from "./string";
export const passwordStrength = password => import("zxcvbn").then(({
  default: zxcvbn
}) => zxcvbn(password).score);
export const getDisplayName = user => {
  const namePartsCompacted = compact([capitalizeWithSeparators(get(user, "forename", "")), capitalizeWithSeparators(get(user, "lastname", ""))]);
  return isEmpty(namePartsCompacted) ? get(user, "username") : namePartsCompacted.join(" ");
};